import GroupingsMixin from './groupings';
import wuxSimulationSorting from './wux-simulation-sorting';

export default {
  mixins: [GroupingsMixin, wuxSimulationSorting],
  computed: {
    blueprintGroupings() {
      return this.groupings.filter(g => g.groupingType === 'Blueprint');
    },
    blueprintGroupingsMap() {
      return this.blueprintGroupings.reduce((map, grouping) => {
        grouping.assetAssociations.forEach((aa) => {
          if (aa.assetBType === 'V3Flashcard') {
            map[aa.assetBId] = grouping;
          }
        });
        return map;
      }, {});
    },
    blueprintId() {
      return this.$route.params.blueprintId;
    },
    isBlueprint() {
      return this.blueprintId !== undefined;
    },
    blueprintGrouping() {
      return this.blueprintGroupings.find(grouping => grouping.id === parseInt(this.blueprintId)) || {
        id: 0,
        name: 'Uncategorized',
      };
    },
    blueprintFlashcards() {
      return this.flashcardsGroupedByBluePrint[this.blueprintId]?.flashcards || [];
    },
    blueprintTallies() {
      const tallies = [];
      Object.keys(this.flashcardsGroupedByBluePrint).forEach((blueprintId) => {
        const flashcardStates = this.getBlueprintFlashcardStates(this.simId, +blueprintId);
        const blueprintGrouping = this.flashcardsGroupedByBluePrint[+blueprintId];
        const flashcards = blueprintGrouping?.flashcards || [];
        const correct = flashcards
          .map((flashcard) => flashcardStates.find(state => state.flashcardId === flashcard.id))
          .filter(state => state?.correct).length;
        const incorrect = flashcards
          .map((flashcard) => flashcardStates.find(state => state.flashcardId === flashcard.id))
          .filter(state => !state?.correct).length;
        tallies.push({
          sectionId: this.sectionId,
          sectionName: blueprintGrouping.name,
          blueprintId: blueprintGrouping.id,
          correct,
          incorrect,
        });
      });
      return tallies;
    },
    flashcardsGroupedByBluePrint() {
      const categoryId = +this.$route.params.simId || +this.$route.params.categoryId;
      const flashcards = this.flashcardsBySection(categoryId);
      const groupedFlashcards = {};
      flashcards.forEach((flashcard) => {
        const blueprintCategory = (
          this.blueprintGroupingsMap[flashcard.id] ||
          {
            id: 0,
            name: 'Uncategorized',
          }
        );

        if (!groupedFlashcards[blueprintCategory.id]) {
          groupedFlashcards[blueprintCategory.id] = {
            id: blueprintCategory.id,
            name: blueprintCategory.name,
            flashcards: [],
          };
        }
        groupedFlashcards[blueprintCategory.id].flashcards.push(flashcard);
      });
      return groupedFlashcards;
    },
  },
  methods: {
    getBlueprintFlashcardStates(categoryId, blueprintId) {
      if (blueprintId === undefined) {
        blueprintId = this.blueprintId;
      }
      const flashcardStates = this.$store.getters['flashcardStates/flashcardStates'];
      return this.flashcardsGroupedByBluePrint[blueprintId]?.flashcards.map(flashcard => {
        return flashcardStates[`${flashcard.id}-category-${categoryId}`] || {
          answerIds: [],
          categoryId,
          correct: false,
          flashcardId: flashcard.id,
          rawAnswerData: null,
          id: `${flashcard.id}-category-${categoryId}`,
        };
      }) || [];
    },
  },
};
